// 全局过滤器
import Vue from 'vue';
import {formatDate} from './util.js';
/*
 * 求百分比
 * */
Vue.filter('fnPercent', function (val, total) {
  if (isNaN(val) || isNaN(total)) { return ''; }
  return Math.round(val / total * 100) + '%';
});
/*
 * 时间戳处理
 * */
Vue.filter('transMinute', function (seconds) {
  if (seconds < 0) { seconds = 0; }
  let iD = Math.floor(seconds / 1440);
  let iH = Math.floor((seconds % 1440) / 60);
  let iS = seconds % 60;
  return (((iD === 0 && iS > 0) || (iD === 0 && iS === 0)) ? '' : (iD + '天')) + (((iH === 0 && iS > 0) || (iH === 0 && iS === 0)) ? '' : (iH + '小时')) +
      ((iH > 0 && iS === 0) ? '' : (iS + '分钟'));
});
/*
 * 时间戳处理
 * */
Vue.filter('transSeconds', function (seconds) {
  let iH = Math.floor(seconds / (60 * 60));
  let iM = Math.floor((seconds - iH * 60 * 60) / 60);
  let iS = seconds % 60;
  return ((iH < 10) ? ('0' + iH) : iH) + ':' +
  ((iM < 10) ? ('0' + iM) : iM) + ':' +
  ((iS < 10) ? ('0' + iS) : iS);
});
/*
 * 时间戳处理
 * */
Vue.filter('fmTimestamp', function (timestamp, fm) {
  return formatDate(timestamp, fm);
});
/*
 * 数量处理
 * @param {int} number 熟练
 * @param {string} currency 单位
 * */
Vue.filter('fmTenThousand', function (number, currency) {
  if (isNaN(number)) { return 0; }
  if (number < 10000) { return number; }
  if (!currency) { currency = '万'; }
  number = Math.round((number / 10000) * 100) / 100;
  number = number + currency;
  return number;
});
/*
 * 截取字符串
 * @param {string} str 字符串
 * @param {int} len 需要截取的长度
 * @param {int} clen 中文所占字节，默认为2
 * @param {string} siff 结尾，默认为"..."
 * */
Vue.filter('strCutWithLen', function (str, len, clen, siff) {
  if (!clen) { clen = 2; }
  if (!siff) { siff = '...'; }
  let ilt = 0, idx = 0, srtn = '';
  if (str && str.length > 0) {
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
        ilt += clen;
      } else {
        ilt += 1;
      }
      if (ilt >= len) {
        idx = i - 1;
        break;
      }
    }
    if (idx > 0) {
      srtn = str.substring(0, idx) + siff;
    } else {
      srtn = str;
    }
  }
  return srtn;
});
/*
 * 手机号安全处理
 * @param {int|string} mobile 手机号
 * */
Vue.filter('mobileSecurity', function (mobile) {
  if (mobile && mobile > 0) {
    if (!mobile || mobile.length < 7) { return mobile; }
    mobile = mobile + '';
    if (mobile.length > 7) {
      let str = '';
      str = mobile.substring(0, 3);
      for (let i = 0; i < mobile.length - 7; i++) {
        str += '*';
      }
      str += mobile.substring(mobile.length - 4, mobile.length);
      return str;
    }
  }
  return mobile;
});
/*
* 数字处理，
* 小于10，自动补零
* */
Vue.filter('zeroFill', function (num) {
  return num < 10 ? '0' + num : num;
})
/*
* 保留小数点2位
*
* */
Vue.filter('toFixed2', function (num) {
  return parseFloat(num).toFixed(2)
})

// 宁夏项目对未加字典的值特殊处理

/*
* 身份处理
* 1机构人员 2老师 3学生 4家长
* */

Vue.filter('identityFilter', function (type) {
  let identObj = {
    '1': '机构人员',
    '2': '老师',
    '3': '学生',
    '4': '家长',
  }
  return identObj[type] ? identObj[type] : identObj['1'];
})